module.exports = __webpack_public_path__ + "static/media/Talq-request.dba11acb.jpg";